import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import type {
	JiraIssueExportType,
	JiraIssueSearchScope,
} from '@atlassian/jira-relay/src/__generated__/exportIssuesTaskFlagSubscription.graphql';

type BasicExportItem = {
	id?: string;
	relativeLink: boolean;
	link: string;
	label: string;
	rel: string;
	xsrfToken?: string;
};

export type AsyncExportItem = BasicExportItem & {
	id: string;
	exportType: JiraIssueExportType;
	maxResults?: number;
	fileExtension: string;
};

export type ExportItemType = BasicExportItem | AsyncExportItem;

export const isAsyncExportItem = (option: ExportItemType): option is AsyncExportItem =>
	'exportType' in option;

type Filter = {
	items: ExportItemType[];
	empty: boolean;
	label?: string;
	id?: string;
};

type ExportViewOptionHeader = {
	label: string;
};

export type ExportItemsResponse = {
	filter: Filter[];
	viewOptionHeader?: ExportViewOptionHeader;
};

export type RequestObject = {
	jql: string;
	filterId?: string;
	modified?: boolean;
	getViewOptionHeader?: boolean;
};

export type UseFetchAllExportIssuesResources = {
	fetch: (arg1: boolean) => Promise<void>;
	exportItems: ExportItemsResponse | undefined;
	loading: boolean;
	error?: Error | undefined;
};

export type LastUsedJql = string | undefined;

export type AsyncExportIssuesCommonInput = {
	jql: string;
	filterId?: string | undefined;
	modified: boolean;
	excludeDoneWorkItems?: boolean;
	scope?: JiraIssueSearchScope;
};

export interface ExportIssuesSubscriptionError extends Error {
	extensions?: {
		classification?: string;
		errorSource?: string;
		errorType?: string;
		statusCode?: number;
	};
}

export type ExportIssuesDownloadErrorResponse = {
	message: string;
	httpStatusCode?: number;
	errorCode?: string;
};

export class ExportIssuesDownloadError extends FetchError {
	errorCode?: string;

	constructor({
		statusCode,
		message,
		traceId,
		errorCode,
		response,
	}: {
		statusCode: number;
		message?: string;
		traceId?: string;
		errorCode?: string;
		response?: Response;
	}) {
		super(statusCode, message, traceId, response);
		this.errorCode = errorCode;
	}
}
